var map = {
	"./APPLEPAY.png": 9337,
	"./Amex.png": 6790,
	"./Benefit.png": 3510,
	"./Cliq.png": 6784,
	"./Credit.png": 3804,
	"./Credit0.png": 7014,
	"./Credit1.png": 815,
	"./Fawry.png": 1746,
	"./KNET.png": 9647,
	"./MADA.png": 8392,
	"./MASTER.png": 5849,
	"./MediaWorld.png": 3291,
	"./Pointcheckout.png": 2229,
	"./Qicard.png": 2935,
	"./Tasdeed.png": 5793,
	"./VISA.png": 5132,
	"./Zaincash.png": 8640,
	"./directpay.png": 7084,
	"./efawateercom.png": 4714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9424;